import { ServicePageTemplate } from "./ServicePageTemplate";
import { getServiceBySlug } from "@/data/services";

const FullBodyMassage = () => (
  <ServicePageTemplate service={getServiceBySlug("full-body-massage")} />
);

export default FullBodyMassage;
